import fullscreenApi from '../lib/fullscreen.js';

export function toggleFullscreen(is_on, element) {
    if (is_on) {
        fullscreenApi.requestFullScreen(element);
    } else {
        fullscreenApi.cancelFullScreen(element);
    }
}

export function onFullscreen(fn) {
    document.documentElement.addEventListener(fullscreenApi.fullScreenEventName, function(){
        fn(fullscreenApi.isFullScreen());
    }, true);
}


// WEBPACK FOOTER //
// ./src/helpers/ui.js